import type { VariantState } from './variantState';

export type EnabledProps = {
	isSunriseEnabled?: boolean;
};

export type EnabledState = {
	enabled: boolean;
	shouldUseBlueCards: boolean;
	isSunriseEnabled: boolean;
} & VariantState;

export function enabledState({ enabled, variant, shouldUseBlueCards, isSunriseEnabled }: EnabledState): EnabledState {
	return {
		enabled,
		variant,
		shouldUseBlueCards,
		isSunriseEnabled,
	};
}
